import React, { useRef } from 'react';
import {useAtom} from "jotai";
import {AIcaptionListState, captionListState} from "../../../states/caption";
import {initializeState, initializeUrlState} from "../../../states/initialize";
import {modalState, saveState} from "../../../states/action";
import {setExport2txt} from "../../../helper/axiosPost";
import { validateCaptionList } from '../../../helper/helper';


/**
 자막 저장
 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */

export default function HeaderSave() {


  const [{job_id, user_id}, setInitialize] = useAtom(initializeState);
  const [captionConfig, ] = useAtom(initializeState);

  const [{uploadCaptionUrl, setCaptionUrl}] = useAtom(initializeUrlState)
  const [captionList] = useAtom(captionListState);
  const [AICaptionList] = useAtom(AIcaptionListState)

  const [{modalOn}, setModalOn] = useAtom(modalState);
  const [{needSaveOn}, setSave] = useAtom(saveState);
  const btnRef = useRef<HTMLButtonElement>(null);

  const saveFile = () => {
    if (job_id != "") {
      if (window.confirm("자막을 저장하시겠습니까?")) {
        // setSave({needSaveOn:false});

        return setExport2txt(uploadCaptionUrl, setCaptionUrl,  job_id, user_id, captionList,AICaptionList,  setSave)

      }
    } else {
      alert("자막 data가 없습니다. job_id가 있는지 확인해주세요.");
    }
  }

  return (
    <>
      <button
        type="button"
        className={"btn_save " + (needSaveOn ? "need_save" : "")}
        onClick={() => {
          const validateResult = validateCaptionList(captionList, captionConfig)
          const isInvalidExist = validateResult.some(v => v.isOverlap || v.isTooLongText || v.isTooLongTime || v.isTooShortTime)
          isInvalidExist
          ? setModalOn({modalOn:modalOn ? modalOn : !modalOn, modalTitle: '자막 검수', modalContentName:'ModalCaptionValidation'})
          : saveFile()
        }}
        ref={btnRef}
      >
        {needSaveOn ?"NEED SAVE" :  "SAVE"}
      </button>
    </>
  );
}
